import React, { useState } from 'react';
import {
  Button,
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { Icons } from '../../atoms';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 100,
    marginLeft: 8,
  },
  contained: {
    backgroundColor: 'black',
    '&:hover': {
      backgroundColor: 'black',
    },
  },
}));

const SelectLang = ({ onChange, disabled }: any) => {
  const classes = useStyles();
  const [langState, setLangState] = useState('ID');
  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | null>(null);

  const handleOpenLang = (event: React.MouseEvent<HTMLButtonElement> | any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseLang = () => {
    setAnchorEl(null);
  };

  const handleChangLang = (val: string) => {
    setLangState(val);
    setAnchorEl(null);
    onChange(val);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Button
        id={id}
        onClick={handleOpenLang}
        variant="contained"
        color="default"
        disabled={disabled}
        size="large"
        classes={{
          root: classes.root,
          contained: classes.contained,
        }}
        startIcon={
          langState === 'ID' ? <Icons.IconLangId /> : <Icons.IconLangEn />
        }
        endIcon={
          anchorEl ? (
            <ExpandLess style={{ color: '#FFFFFF' }} />
          ) : (
            <ExpandMore style={{ color: '#FFFFFF' }} />
          )
        }
      >
        <Typography style={{ color: 'white' }}>{langState}</Typography>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseLang}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <ListItem button onClick={() => handleChangLang('ID')}>
          <ListItemIcon style={{ minWidth: '40px' }}>
            <Icons.IconLangId />
          </ListItemIcon>
          <ListItemText primary="ID" />
        </ListItem>
        <ListItem button onClick={() => handleChangLang('EN')}>
          <ListItemIcon style={{ minWidth: '35px' }}>
            <Icons.IconLangEn />
          </ListItemIcon>
          <ListItemText primary="EN" />
        </ListItem>
      </Popover>
    </>
  );
};

export default SelectLang;
